<script setup lang="ts">
import { useMiscResizeStore } from '~/stores/miscResize'

const { SETUP_EVENT_LISTENERS, COMPUTE_AND_SET_SCREEN_SIZE } =
  useMiscResizeStore()

onMounted(() => {
  COMPUTE_AND_SET_SCREEN_SIZE()
  SETUP_EVENT_LISTENERS()
})
</script>

<template>
  <div class="layoutWrapper barren">
    <slot />
  </div>
</template>
